import { isEmpty } from "lodash";

interface IDataStore {
  [treatmentId: string]: any
};

export class CompareDataTreatmentsStored {
  private dataStore: IDataStore = {};

  constructor() { }

  setDataByTreatmentId(id: string, data: any) {
    if (id) {
      this.dataStore[id] = data;
    }
  }

  getDataByTreatmentId(id: string) {
    return this.dataStore[id];
  }

  getArrayDataTreatments(treatmentIds?: number[]) {
    const result = [];
    if (!isEmpty(this.dataStore)) {
      for (const key in this.dataStore) {
        if (this.dataStore.hasOwnProperty(key)) {
          const treatmentId = parseInt(key);
          if (!isEmpty(treatmentIds) && !treatmentIds.includes(treatmentId)) {
            continue;
          }
          const data = this.dataStore[key];
          result.push(data);
        }
      }
    }
    return result;
  }

  filterNotExistedDataTreatmentIds(treatmentIds: number[]) {
    const result = treatmentIds.filter(id => {
      return !this.dataStore[id];
    });
    return result;
  }

  resetDataByTreatments() {
    this.dataStore = {};
  }
}
